import SelectDateTime from 'components/Forms/SelectDateTime';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

interface Props {
    name: string;
    originalEventDateFrom?: string;
}

const DateFrom = (props: Props) => {
    const { setValue } = useFormContext();

    useEffect(() => {
        setTimeout(() => {
            if (!props.originalEventDateFrom) return;
            setValue(props.name, new Date(props.originalEventDateFrom));
        }, 100)
    }, [])

    return (
        <SelectDateTime
            name={props.name}
            label='Start dato og tid'
            className='w-full'
            format="datetime"
        />
    )
}

export default DateFrom;
